// extracted by mini-css-extract-plugin
export var divider = "articlefooter-module--divider--a1597";
export var footerWrapper = "articlefooter-module--footerWrapper--8164a";
export var shareSection = "articlefooter-module--shareSection--2056b";